export default __webpack_public_path__ + "images/icons/small-arrow-right-b3483d32f7d4fd70656a6bab9b551299.svg";